module.exports = __webpack_public_path__ + "static/media/s17_color.ba7eec24.pdf";